module.exports = __webpack_public_path__ + "img/CAuger64_ua.16821bc9.webp";